module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.88dfb69.woff2";